import DramaCard from './DramaCard';

/**
 * DramaGrid - Simple grid without in-feed ads
 * In-player ads handled in Player component
 */
function DramaGrid({ dramas, onOpenModal, isLoading = false }) {
    if (isLoading) {
        return (
            <div className="skeleton-grid">
                {[...Array(12)].map((_, i) => (
                    <div key={i} className="skeleton-card"></div>
                ))}
            </div>
        );
    }

    if (!dramas || dramas.length === 0) {
        return (
            <div style={{ padding: '40px', textAlign: 'center', color: '#999' }}>
                <i className="fas fa-film" style={{ fontSize: '3rem', marginBottom: '1rem', opacity: 0.5 }}></i>
                <p>Tidak ada drama tersedia</p>
            </div>
        );
    }

    return (
        <div className="drama-grid">
            {dramas.map((drama) => (
                <DramaCard
                    key={drama.id || drama.bookId}
                    drama={drama}
                    onOpenModal={onOpenModal}
                />
            ))}
        </div>
    );
}

export default DramaGrid;
